import { defineComponent as _defineComponent } from 'vue'
import { CurrencyDollarIcon, RefreshIcon } from '@heroicons/vue/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraProcessingCostsHeader',
  props: {
    isLoading: { type: Boolean, required: true }
  },
  emits: ["refresh"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;

const __returned__ = { emit, get CurrencyDollarIcon() { return CurrencyDollarIcon }, get RefreshIcon() { return RefreshIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})